import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export interface MarkdownRendererProps {
  markdown: string;
  className?: string;
}

export function MarkdownRenderer({ markdown, className = '' }: MarkdownRendererProps) {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (props) => <h1 className="text-base font-semibold text-slate-900 dark:text-white mb-2 mt-4 first:mt-0" {...props} />,
          h2: (props) => <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-2 mt-4 first:mt-0" {...props} />,
          h3: (props) => <h3 className="text-sm font-semibold text-slate-900 dark:text-white mb-2 mt-3 first:mt-0" {...props} />,
          p: (props) => <p className="text-sm text-slate-700 dark:text-zinc-300 leading-6 mb-2 last:mb-0" {...props} />,
          ul: (props) => <ul className="list-disc pl-5 space-y-1 mb-2 last:mb-0 text-sm text-slate-700 dark:text-zinc-300" {...props} />,
          ol: (props) => <ol className="list-decimal pl-5 space-y-1 mb-2 last:mb-0 text-sm text-slate-700 dark:text-zinc-300" {...props} />,
          li: (props) => <li className="leading-6" {...props} />,
          strong: (props) => <strong className="font-semibold text-slate-900 dark:text-white" {...props} />,
          em: (props) => <em className="italic text-slate-700 dark:text-zinc-300" {...props} />,
          blockquote: (props) => (
            <blockquote className="border-l-2 border-slate-200 dark:border-zinc-600 pl-3 text-sm text-slate-600 dark:text-zinc-400 mb-2" {...props} />
          ),
          code: ({ inline, className: codeClassName, ...props }: any) =>
            inline ? (
              <code className="rounded bg-slate-100 dark:bg-zinc-800 px-1 py-0.5 text-[0.85em] text-slate-800 dark:text-zinc-200" {...props} />
            ) : (
              <code
                className={`block rounded-lg bg-slate-950 dark:bg-zinc-950 px-3 py-2 text-xs text-slate-100 overflow-x-auto ${
                  codeClassName || ''
                }`}
                {...props}
              />
            ),
          a: (props) => (
            <a
              className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 underline underline-offset-2"
              target="_blank"
              rel="noreferrer"
              {...props}
            />
          ),
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
